// extracted by mini-css-extract-plugin
export default {"root":"Sn15KKNl"};